import { Plazo } from './../../../models/plazo.model';
import { Component } from "@angular/core";
import {  FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';

@Component({
    selector: "page-plazo",
    templateUrl: "./plazo.component.html",
    providers: [FormService]
})

export class PlazoComponent {
    public rows = [];
    public actualRow;
    public plazo: Plazo;
    public form;
    matcher = new FormService();
    

    constructor(){

        this.form = new FormGroup({
      
            plazo: new FormControl('')
          })
    if(!JSON.parse(localStorage.getItem("plazo"))){
        localStorage.setItem("plazo", JSON.stringify(this.rows));
    }else{
        this.rows = JSON.parse(localStorage.getItem("plazo"));

        this.form.controls['plazo'].setValue(this.rows[0]?this.rows[0].plazo:'');
    }
   // this.plazo = { plazo:0};

    

}

add_plazo(){
    localStorage.setItem("plazo",JSON.stringify([]));
    this.actualRow = localStorage.getItem("plazo");
    this.rows = JSON.parse(this.actualRow);
    this.rows = this.rows.concat({
         plazo : this.form.value.plazo
     
    })
    localStorage.setItem("plazo", JSON.stringify(this.rows));
    //this.form.reset();//
}

delete_plazo(id){
    for(let x = 0; x < this.rows.length; x++){
        if(id == x){
            this.rows.splice(x, 1);
            localStorage.setItem("plazo", JSON.stringify(this.rows));
        }
    }
}  
}